/* Wicket – Accueil et Commande spéciale (sections/wicket-home.liquid, wicket-commande.liquid) : apparitions au défilement, titres et phrase qui sortent d'un masque, filets qui se tracent, bande des coupes (épinglée aussi sur téléphone avec son titre, comme les vestes, les souliers et les magasins), films et vidéos de magasin, garde-robe, texte du héros qui s'efface en descendant. */
(function(){
  if(window.__wkhm) return; window.__wkhm = 1;
  var d = document, w = window;
  var rm = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mqD = w.matchMedia('(min-width: 769px)');
  var io = null, strips = [], ticking = false, hhDone = false;
  var REVEAL = '[data-r],[data-t],[data-words],[data-draw],[data-lines],[data-dates],.wkhm-reveal,.wkhm-co-pillars,.wkhm-co-price,[data-bp]';

  function show(el){ el.classList.add('is-in'); }
  function observe(els){
    if(rm || !('IntersectionObserver' in w)){ els.forEach(show); return; }
    if(!io) io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ show(x.target); io.unobserve(x.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.12});
    els.forEach(function(e){ io.observe(e); });
  }

  // Sur téléphone, les photos d'une rangée qui glisse apparaissent ensemble, y compris celle qui dépasse à droite.
  // On surveille le bloc entier et non la rangée : épinglée, la rangée est décalée de côté et peut sortir de l'écran.
  function group(t){
    var kids = [].slice.call(t.querySelectorAll('.wkhm-reveal'));
    if(rm || !('IntersectionObserver' in w)){ kids.forEach(show); return; }
    var o = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ kids.forEach(show); o.disconnect(); } });
    }, {rootMargin:'0px 0px -10% 0px', threshold:0});
    o.observe(t.closest('section') || t);
  }

  // Les rangées qui glissent de côté chargent leurs photos dès qu'elles approchent : le chargement différé du navigateur ne voit pas toujours les photos décalées sur le côté.
  function eager(root){
    var tracks = [].slice.call(root.querySelectorAll('.wkhm-swipe'));
    function go(t){ [].forEach.call(t.querySelectorAll('img[loading="lazy"]'), function(i){ i.loading = 'eager'; }); }
    if(!('IntersectionObserver' in w)){ tracks.forEach(go); return; }
    tracks.forEach(function(t){
      var o = new IntersectionObserver(function(en){
        if(en.some(function(x){ return x.isIntersecting; })){ go(t); o.disconnect(); }
      }, {rootMargin:'900px 0px 900px 0px'});
      o.observe(t.closest('section') || t);
    });
  }

  function words(el){
    if(el.getAttribute('data-split')) return; el.setAttribute('data-split','1');
    var i = 0;
    (function walk(n){
      [].slice.call(n.childNodes).forEach(function(c){
        if(c.nodeType === 3){
          var f = d.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function(p){
            if(!p) return;
            if(/^\s+$/.test(p)){ f.appendChild(d.createTextNode(' ')); return; }
            var o = d.createElement('span'); o.className = 'w';
            var s = d.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            o.appendChild(s); f.appendChild(o);
          });
          n.replaceChild(f, c);
        } else if(c.nodeType === 1 && c.tagName !== 'BR'){ walk(c); }
      });
    })(el);
  }

  // Hauteur de l'en-tête fixe, pour la colonne fixe et la bande épinglée.
  function headerH(){
    var max = 0;
    [d.querySelector('.site-header--stuck'), d.querySelector('.header-sticky-wrapper'), d.querySelector('.header-wrapper'), d.getElementById('SiteHeader')].forEach(function(h){
      if(!h) return;
      var cs = w.getComputedStyle(h);
      if(cs.position === 'fixed' || cs.position === 'sticky'){ var b = h.getBoundingClientRect().bottom; if(b > max) max = b; }
    });
    return Math.round(max);
  }
  function setHH(){
    var h = headerH();
    if(h > 40){ [].forEach.call(d.querySelectorAll('.wkhm'), function(r){ r.style.setProperty('--wkhm-hh', Math.min(h, 140) + 'px'); }); return true; }
    return false;
  }

  function Strip(sec){
    this.sec = sec;
    this.track = sec.querySelector('.wkhm-strip__track');
    this.dist = 0; this.on = false;
    var self = this;
    this.track.addEventListener('dragstart', function(e){ e.preventDefault(); });
    this.measure();
    w.addEventListener('resize', function(){ self.measure(); });
    if(mqD.addEventListener) mqD.addEventListener('change', function(){ self.measure(); });
  }
  Strip.prototype.measure = function(){
    var desk = mqD.matches && !rm;
    this.sec.classList.remove('is-pinned', 'is-static');
    this.sec.style.height = '';
    // Téléphone : la rangée appartient à l'épinglage PinM, qui gère son déplacement ; ne pas l'effacer ici
    // (la barre de Safari qui se replie déclenche un « resize », et la rangée sautait à zéro jusqu'au défilement suivant).
    if(!desk){ this.on = false; if(!this.track.classList.contains('is-pinm')) this.track.style.transform = ''; return; }
    this.track.style.transform = '';
    this.dist = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    if(this.dist < 60){ this.on = false; this.sec.classList.add('is-static'); return; }
    this.on = true;
    this.sec.classList.add('is-pinned');
    this.dist = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.hold = Math.round(w.innerHeight * 0.3);
    this.len = Math.round(this.dist / 1.6);
    this.sec.style.height = (w.innerHeight + this.hold + this.len + Math.round(this.hold * 0.6)) + 'px';
    this.update();
  };
  Strip.prototype.update = function(){
    if(!this.on) return;
    var r = this.sec.getBoundingClientRect();
    var p = this.len > 0 ? Math.min(1, Math.max(0, (-r.top - this.hold) / this.len)) : 0;
    this.track.style.transform = 'translate3d(' + (-p * this.dist).toFixed(1) + 'px,0,0)';
    this.sec.style.setProperty('--p', p.toFixed(4));
  };

  function Film(sec){
    var v = sec.querySelector('video'), btn = sec.querySelector('.wkhm-film__btn'), self = this;
    this.sec = sec; this.v = v; this.btn = btn; this.vis = false; this.user = false;
    if(!v) return;
    v.muted = true; v.setAttribute('muted', '');
    this.pick();
    if(mqD.addEventListener) mqD.addEventListener('change', function(){ self.pick(true); });
    if(btn) btn.addEventListener('click', function(){
      if(v.paused){ self.user = false; self.play(); } else { self.user = true; v.pause(); self.state(); }
    });
    v.addEventListener('play', function(){ self.state(); });
    v.addEventListener('pause', function(){ self.state(); });
    if(rm){ this.user = true; this.state(true); }
    if('IntersectionObserver' in w){
      new IntersectionObserver(function(en){
        en.forEach(function(x){
          self.vis = x.isIntersecting;
          if(self.vis && !self.user) self.play(); else if(!self.vis && !v.paused) v.pause();
        });
      }, {rootMargin:'200px 0px 200px 0px'}).observe(sec);
    } else if(!rm){ this.play(); }
  }
  Film.prototype.pick = function(reload){
    var v = this.v, m = !mqD.matches;
    var s = (m && v.getAttribute('data-src-m')) || v.getAttribute('data-src');
    var p = (m && v.getAttribute('data-poster-m')) || v.getAttribute('data-poster');
    if(p && v.getAttribute('poster') !== p) v.setAttribute('poster', p);
    if(this.src !== s){
      this.src = s;
      if(this.loaded || reload){ v.src = s; this.loaded = true; if(this.vis && !this.user) this.play(); }
    }
  };
  Film.prototype.play = function(){
    var v = this.v;
    if(!this.loaded){ v.src = this.src; this.loaded = true; }
    var pr = v.play(); if(pr && pr.catch) pr.catch(function(){});
  };
  Film.prototype.state = function(force){
    var paused = force || this.v.paused;
    this.sec.classList.toggle('is-paused', !!paused);
    if(this.btn) this.btn.setAttribute('aria-label', this.btn.getAttribute(paused ? 'data-l-play' : 'data-l-pause'));
  };

  // Vidéos d'ambiance (magasins) : chargées et lues seulement à l'écran ; image fixe si moins de mouvement.
  function ambient(root){
    [].forEach.call(root.querySelectorAll('video[data-src]'), function(v){
      if(v.closest('[data-film]')) return;
      v.muted = true; v.setAttribute('muted', '');
      if(rm) return;
      var loaded = false;
      function play(){ if(!loaded){ v.src = v.getAttribute('data-src'); loaded = true; } var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
      if(!('IntersectionObserver' in w)){ play(); return; }
      new IntersectionObserver(function(en){
        en.forEach(function(x){ if(x.isIntersecting) play(); else if(!v.paused) v.pause(); });
      }, {rootMargin:'200px 0px 200px 0px'}).observe(v);
    });
  }

  // Plan du costume : la feuille s'incline légèrement en suivant la souris (ordinateur) ; la liste allume le repère correspondant.
  function blueprint(wrap){
    var bp = wrap.querySelector('[data-bp]'); if(!bp) return;
    var sheet = bp.querySelector('.wkhm-bp__sheet'), raf = 0, px = 0, py = 0;
    [].forEach.call(bp.querySelectorAll('path.l'), function(p){
      try { p.style.setProperty('--len', Math.ceil(p.getTotalLength() + 2)); } catch(e) {}
    });
    [].forEach.call(wrap.querySelectorAll('.wkhm-bp-list li[data-k]'), function(li){
      var k = li.getAttribute('data-k');
      function on(){ bp.setAttribute('data-hl', k); }
      function off(){ if(bp.getAttribute('data-hl') === k) bp.removeAttribute('data-hl'); }
      li.addEventListener('mouseenter', on); li.addEventListener('focus', on);
      li.addEventListener('mouseleave', off); li.addEventListener('blur', off);
    });
    if(rm || !w.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    function apply(){ raf = 0; sheet.style.setProperty('--mx', (px * 7).toFixed(2) + 'deg'); sheet.style.setProperty('--my', (-py * 5).toFixed(2) + 'deg'); }
    bp.addEventListener('mousemove', function(e){
      var r = bp.getBoundingClientRect();
      px = (e.clientX - r.left) / r.width - 0.5; py = (e.clientY - r.top) / r.height - 0.5;
      if(!raf) raf = w.requestAnimationFrame(apply);
    });
    bp.addEventListener('mouseleave', function(){ px = 0; py = 0; if(!raf) raf = w.requestAnimationFrame(apply); });
  }

  function index(sec){
    var figs = [].slice.call(sec.querySelectorAll('.wkhm-index__stage figure'));
    function on(n){
      if(!figs.some(function(f){ return f.getAttribute('data-f') === n; })) return;
      figs.forEach(function(f){ f.classList.toggle('is-on', f.getAttribute('data-f') === n); });
    }
    [].forEach.call(sec.querySelectorAll('a[data-i]'), function(a){
      var n = a.getAttribute('data-i');
      a.addEventListener('mouseenter', function(){ on(n); });
      a.addEventListener('focus', function(){ on(n); });
    });
  }

  // Vestes : la colonne de droite glisse un peu plus vite que celle de gauche (ordinateur seulement).
  var splits = [];
  function splitDrift(){
    if(rm || !mqD.matches) return;
    var vh = w.innerHeight;
    splits.forEach(function(g){
      var r = g.getBoundingClientRect();
      if(r.bottom < -200 || r.top > vh + 200) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
      g.style.setProperty('--py', (p * 90).toFixed(1) + 'px');
    });
  }

  // Téléphone : les rangées des costumes, des vestes, des souliers et des magasins restent épinglées pendant que la page descend,
  // et défilent de côté, comme sur ordinateur. Toutes s'arrêtent au même endroit, au milieu de l'écran : la plus haute rangée est
  // centrée entre l'en-tête et le bas de l'écran (100dvh suit la barre du navigateur quand elle se replie), les autres commencent
  // à la même hauteur. Au-dessus, la ligne de texte (« Découvrir les … », « Nos magasins ») reste quand il y a la place ;
  // une ligne que l'en-tête couperait à moitié s'efface pendant l'arrêt.
  // Quand le navigateur sait lier une animation au défilement (Safari 26, Chrome), le déplacement de côté est confié au CSS
  // (classe is-sda, chronologie « --wkpin » posée sur la section) : il suit la page image par image, sans passer par le script.
  // Sinon (anciens iPhone), le script le calcule à chaque image, comme avant.
  var SDA = !!(w.CSS && CSS.supports && CSS.supports('view-timeline-name', '--wkpin') && CSS.supports('animation-timeline', '--wkpin') && CSS.supports('animation-range-start', 'exit-crossing calc(10px - max(0px, (100lvh - 300px) / 2))'));
  var pins = [];
  function PinM(row){ this.row = row; this.sec = row.closest('.wkhm-strip, .wkhm-split, .wkhm-trio, .wkhm-shops') || row.parentNode; this.on = false; this.sp = null; this.g = null; this.stuck = false; this.sda = false; }
  PinM.prototype.off = function(){
    var r = this.row, g = this.g;
    r.classList.remove('is-pinm', 'is-sda'); r.style.transform = '';
    r.style.removeProperty('--wk-dist'); r.style.removeProperty('--wk-rs'); r.style.removeProperty('--wk-re');
    this.sec.style.removeProperty('view-timeline-name'); this.sda = false;
    if(g){
      [].forEach.call(g.querySelectorAll('.wkhm-pinm-cut'), function(e){ e.classList.remove('wkhm-pinm-cut'); });
      if(g.parentNode){ while(g.firstChild) g.parentNode.insertBefore(g.firstChild, g); g.parentNode.removeChild(g); }
    }
    if(this.sp && this.sp.parentNode) this.sp.parentNode.removeChild(this.sp);
    this.g = null; this.sp = null; this.on = false; this.stuck = false;
  };
  // Première étape : envelopper le bloc et mesurer sa rangée, sans rien épingler encore.
  PinM.prototype.prep = function(){
    this.off();
    if(rm || mqD.matches) return false;
    var r = this.row, sec = this.sec, dist = r.scrollWidth - r.clientWidth;
    if(dist < 40) return false;
    var g = d.createElement('div');
    g.className = 'wkhm-pinm-g';
    while(sec.firstChild) g.appendChild(sec.firstChild);
    sec.appendChild(g);
    r.classList.add('is-pinm');
    var gt = g.getBoundingClientRect().top, rr = r.getBoundingClientRect(), rt = rr.top - gt;
    this.g = g; this.dist = dist; this.rt = rt; this.rh = rr.height; this.gh = g.offsetHeight;
    this.marks = [].filter.call(g.querySelectorAll('.wkhm-eyebrow, .wkhm-title, .wkhm-rule, .wkhm-text, .wkhm-link'), function(e){
      return !r.contains(e) && e.offsetParent;
    }).map(function(e){ var b = e.getBoundingClientRect(); return {e: e, t: b.top - gt, b: b.bottom - gt}; })
      .filter(function(m){ return m.b <= rt + 0.5; });
    return true;
  };
  // Seconde étape : épingler à la hauteur commune (voir pinK). La hauteur d'écran est prise barres repliées (100lvh) :
  // avec 100dvh, le bloc et sa rangée sautaient chaque fois que la barre de Safari se repliait ou se dépliait.
  PinM.prototype.place = function(){
    var g = this.g, r = this.row, off = Math.round(pinHH - this.rt);
    var mid = 'max(0px, (100lvh - ' + (pinHH + pinRH) + 'px) / 2)';
    g.style.top = 'calc(' + mid + ' + ' + off + 'px)';
    g.classList.add('is-on');
    this.hold = Math.round(Math.min(110, w.innerHeight * 0.12));
    this.len = Math.round(this.dist / 1.3);
    var sp = d.createElement('div');
    sp.className = 'wkhm-pinm-sp'; sp.setAttribute('aria-hidden', 'true');
    sp.style.height = (this.len + 2 * this.hold) + 'px';
    this.sec.appendChild(sp);
    this.sp = sp; this.on = true; this.sda = false;
    if(SDA){
      // La rangée va de 0 à -dist pendant que le haut de la section passe de (top - hold) à (top - hold - len) au-dessus du haut de l'écran
      // (plage « exit-crossing » : son 0 % est le passage du haut de la section sous le haut de l'écran, quelle que soit la hauteur de la section).
      this.sec.style.setProperty('view-timeline-name', '--wkpin');
      r.style.setProperty('--wk-dist', (-this.dist) + 'px');
      r.style.setProperty('--wk-rs', 'exit-crossing calc(' + (this.hold - off) + 'px - ' + mid + ')');
      r.style.setProperty('--wk-re', 'exit-crossing calc(' + (this.hold + this.len - off) + 'px - ' + mid + ')');
      r.style.transform = '';
      r.classList.add('is-sda');
      this.sda = true;
      try {
        var an = r.getAnimations().filter(function(a){ return a.animationName === 'wkhm-pan'; })[0];
        var src = an && an.timeline && an.timeline.source;
        if(!an || (src && src !== d.scrollingElement)) throw 0;
      } catch(e){
        r.classList.remove('is-sda'); this.sec.style.removeProperty('view-timeline-name'); this.sda = false;
      }
    }
    this.update();
  };
  // Les lignes que l'en-tête couperait à moitié (k : place entre l'en-tête et le haut des photos).
  PinM.prototype.cut = function(k){
    var c = this.rt - k;
    this.marks.forEach(function(m){ m.e.classList.toggle('wkhm-pinm-cut', m.t < c - 0.5 && m.b > c + 0.5); });
  };
  PinM.prototype.update = function(){
    if(!this.on) return;
    var flow = this.sp.getBoundingClientRect().top - this.gh;
    var off = this.g.getBoundingClientRect().top - flow;
    if(!this.sda){
      var p = Math.min(1, Math.max(0, (off - this.hold) / this.len));
      this.row.style.transform = 'translate3d(' + (-p * this.dist).toFixed(1) + 'px,0,0)';
    }
    var stuck = off > 0.5 && off < this.len + 2 * this.hold - 0.5;
    if(stuck !== this.stuck){ this.stuck = stuck; this.g.classList.toggle('is-stuck', stuck); }
  };
  var pinW = w.innerWidth, pinH = w.innerHeight;
  // Une seule hauteur d'arrêt pour toute la page : la plus haute rangée est centrée entre l'en-tête et le bas de l'écran.
  var pinHH = 0, pinRH = 0;
  function pinK(){ return Math.max(0, (w.innerHeight - pinHH - pinRH) / 2); }
  function pinsCut(){ var k = pinK(); pins.forEach(function(p){ if(p.on) p.cut(k); }); }
  function pinsMeasure(){
    var on = pins.filter(function(p){ return p.prep(); });
    if(!on.length) return;
    var sh = d.getElementById('SiteHeader');
    pinHH = Math.max(headerH() || 0, sh ? Math.round(sh.getBoundingClientRect().height) : 0);
    pinRH = Math.ceil(Math.max.apply(null, on.map(function(p){ return p.rh; })));
    on.forEach(function(p){ p.place(); });
    pinsCut();
  }
  w.addEventListener('resize', function(){
    pinsCut();
    if(Math.abs(w.innerWidth - pinW) < 3 && Math.abs(w.innerHeight - pinH) < 120) return;
    pinW = w.innerWidth; pinH = w.innerHeight; pinsMeasure();
  });
  if(mqD.addEventListener) mqD.addEventListener('change', pinsMeasure);

  var hero = d.querySelector('.index-section--hero .hero__text-shadow');
  function heroDrift(){
    if(!hero || rm || !d.documentElement.classList.contains('wkhm-hm')) return;
    var y = w.pageYOffset || 0, vh = w.innerHeight;
    if(y > vh * 1.2) return;
    var k = Math.min(1, y / (vh * 0.65));
    hero.style.setProperty('--wkhm-hy', (y * 0.22).toFixed(1) + 'px');
    hero.style.setProperty('--wkhm-ho', (1 - k * 0.9).toFixed(3));
  }

  function frame(){
    ticking = false;
    if(!hhDone && (w.pageYOffset || 0) > w.innerHeight * 0.4){ hhDone = setHH(); if(hhDone) strips.forEach(function(s){ s.measure(); }); }
    strips.forEach(function(s){ s.update(); });
    pins.forEach(function(p){ p.update(); });
    splitDrift();
    heroDrift();
  }
  w.addEventListener('scroll', function(){ if(!ticking){ ticking = true; w.requestAnimationFrame(frame); } }, {passive:true});

  function init(root){
    if(!root || root.getAttribute('data-wkhm-ready')) return;
    root.setAttribute('data-wkhm-ready', '1');
    root.classList.add('wkhm--js');
    [].forEach.call(root.querySelectorAll('[data-words]'), words);
    var mob = !mqD.matches;
    observe([].slice.call(root.querySelectorAll(REVEAL)).filter(function(e){
      return !(mob && e.classList.contains('wkhm-reveal') && e.closest('.wkhm-swipe'));
    }));
    if(mob) [].forEach.call(root.querySelectorAll('.wkhm-swipe'), group);
    eager(root);
    [].forEach.call(root.querySelectorAll('[data-strip]'), function(s){ strips.push(new Strip(s)); });
    [].forEach.call(root.querySelectorAll('[data-film]'), function(s){ new Film(s); });
    ambient(root);
    [].forEach.call(root.querySelectorAll('[data-index]'), index);
    [].forEach.call(root.querySelectorAll('[data-bpwrap]'), blueprint);
    [].forEach.call(root.querySelectorAll('[data-split] .wkhm-split__grid'), function(g){ splits.push(g); });
    [].forEach.call(root.querySelectorAll('.wkhm-strip .wkhm-strip__track, .wkhm-split__grid, .wkhm-trio__grid, .wkhm-shops__grid'), function(r){ pins.push(new PinM(r)); });
  }
  function all(){ setHH(); [].forEach.call(d.querySelectorAll('.wkhm'), init); pinsMeasure(); frame(); }
  if(d.readyState === 'loading') d.addEventListener('DOMContentLoaded', all); else all();
  w.addEventListener('load', function(){ setHH(); strips.forEach(function(s){ s.measure(); }); pinsMeasure(); });
  d.addEventListener('shopify:section:load', function(){ strips = []; pins.forEach(function(p){ p.off(); }); pins = []; all(); });
})();
